var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-customer-rotator"},[_c('div',{staticClass:"row"},_vm._l((_vm.display_customers),function(customer,i){return _c('div',{key:i,staticClass:"small-6 customer_column"},[_c('transition-group',{staticStyle:{"position":"relative"},attrs:{"name":"fade-in-customers","tag":"div","mode":"out-in"}},[_c('img',{key:customer.name,attrs:{"src":'/static/images/customer-logos/'+customer.name+'.png',"alt":""}})])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cca0d72","hasScoped":true,"buble":{"transforms":{}}}!./src/components/customer-rotator/customer-rotator.html
// module id = null
// module chunks = 